import { Flex, Spin } from 'antd';
import { RouterProvider } from 'react-router-dom';
import { OfflineBanner } from '@/shared/offline-banner';
import { AntdProvider, PwaUpdatePrompt, StoreProvider } from './providers';
import { useBootstrap } from './bootstrap/useBootstrap';
import { router } from './router';

function Bootstrapped() {
  const ready = useBootstrap();

  if (!ready) {
    return (
      <Flex align="center" justify="center" style={{ minHeight: '100vh' }}>
        <Spin size="large" />
      </Flex>
    );
  }

  return (
    <>
      <OfflineBanner />
      <PwaUpdatePrompt />
      <RouterProvider router={router} />
    </>
  );
}

export function App() {
  return (
    <StoreProvider>
      <AntdProvider>
        <Bootstrapped />
      </AntdProvider>
    </StoreProvider>
  );
}
